export const ExceptionsAndOpportunity = {
  Postcode: 1,
  Service: 2,
  Duty: 3,
  Opportunity: 4,
};

export const StopType = {
  TenThirty: 3,
  Twelve: 4,
  Evening: 8,
};

export const DriverRequests = {
  Requests: 1,
};

export const LoadTime = {
  OnSchedule: 1,
  BehindSchedule: 2,
  ScanTimeExceeded: 3,
};

export const StopTypes = {
  delivery: 'Delivery',
  collections: 'Collection',
  timed: 'Timed',
  pickup: 'Pickup',
  perishable: 'Perishable',
  vip: 'VIP',
  bulk: 'Bulk',
  premium: 'Premium',
  swapit: 'Swapit',
  smalls: 'Smalls',
};

export const StopProgress = {
  nonCAD: 'Non-CAD',
  nonLoaded: 'Not Loaded',
  CAD: 'CAD',
  loaded: 'Loaded',
};
export const StopServices = {
  tenThirty: '10:30',
  twelve: '12:00',
  precise: 'Precise',
  afternoon: 'Afternoon',
  evening: 'Evening',
  saturday: 'Saturday',
  sunday: 'Sunday',
};
export const StopExceptions = {
  none: 'none',
  postcode: 1,
  service: 2,
  duty: 3,
  opportunity: 4,
  range: 6,
  legalDuty: 7,
};
